import styled from 'styled-components';
import { InlineIcon } from '@styles/common';

interface BoolIconProps {
  $on?: boolean;
}

export const BoolIcon = styled(InlineIcon)<BoolIconProps>`
  color: ${(props) => (props.$on ? '#12a512' : '#bf5b4c')};
`;
